// Registro de fontes baixadas na impressora (recurso do projeto).
// ponytail: registro em memória por enquanto — persistência por tenant fica para a fase de upload (~DU/~DB).

/**
 * @typedef {Object} DownloadedFont
 * @property {string} alias     — letra A-Z/0-9 que o ZPL usa via ^CW
 * @property {string} fileName  — ex.: 'MYFONT.TTF'
 * @property {string} [device]  — default 'E:'
 * @property {string} [data]    — bytes da fonte para ~DU
 */

const registry = new Map();

export function registerDownloadedFont(name, font) {
  registry.set(String(name), font);
}

export function getDownloadedFont(name) {
  return registry.get(String(name));
}

export function listDownloadedFonts() {
  return Array.from(registry.keys());
}
